import { render, staticRenderFns } from "./LunchDayRow.vue?vue&type=template&id=c48d7ae8&"
import script from "./LunchDayRow.vue?vue&type=script&lang=js&"
export * from "./LunchDayRow.vue?vue&type=script&lang=js&"
import style0 from "./LunchDayRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports